<template>
  <div id="mark-modal-shop-select">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Пост промаркирован</h3>
          </div>
          <div class="modal-body">
            <template v-if="isInviteToSave()">
              Успешная маркировка поста
            </template>
            <template v-else>
              Успешная маркировка поста
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, onMounted, onUnmounted, reactive, watch} from "vue"
import {eventBus} from "@/plugins/event_bus/event_bus"
import {eventBindMarkComplete} from "@/modules/post/components/mark_ad/services/data"

export default defineComponent({
  name: "Complete",
  components: {},
  props: {
    payload: {
      type: Object,
      required: true
    },
  },
  setup(props) {
    const payload = reactive({
      post_id: null,
      post_status: null,
    })

    onMounted(() => {
      updatePayload(props.payload)
      eventMarkComplete()
    })

    onUnmounted(() => {})

    watch(() => props.payload, (val) => {
      updatePayload(val)
    })

    function eventMarkComplete() {
      eventBus.emit(eventBindMarkComplete, {
        "complete": true,
      })
    }

    function updatePayload(query) {
      payload.post_id = query.post_id
      payload.post_status = query.post_status
    }

    function getPostId() {
      return payload.post_id
    }

    function isPostStatusPublished() {
      return payload.post_status === "published"
    }

    function isPostStatusScheduled() {
      return payload.post_status === "scheduled"
    }

    function isInviteToSave() {
      return isPostStatusPublished() || isPostStatusScheduled()
    }

    return {
      getPostId,
      isInviteToSave,
    }
  }
})
</script>
